import { CommonService } from './../../../../services/utils/common.service';
import { ReservationPrint } from 'app/models/reservation-print.model';
import { LoyaltyPrintTemplateService } from 'app/services/loyalty/loyalty-print-template.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { LoyaltyGiftReservationService } from './../../../../services/loyalty/loyalty-gift-reservation.service';
import { SelectItem, ConfirmationService } from 'primeng/components/common/api';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { Component, OnInit, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { LoyaltyReservationsService } from 'app/services/loyalty/loyalty-reservations.service';
import { debug } from 'console';

@Component({
  selector: 'app-confirm-gift-reservation-form',
  templateUrl: './confirm-gift-reservation-form.component.html',
  styleUrls: ['./confirm-gift-reservation-form.component.css']
})
export class ConfirmGiftReservationFormComponent implements OnInit {
  regex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);
  customFilter = KontableComponent.CustomFilter;
  immediateContribution = 0;
  pickupContribution = 0;
  pdvDelivery = false;
  digitalDelivery = false;
  homeDelivery = false;
  pdvOrHomeDelivery: string;
  selectedPdv: any;
  reservationEmail: string;
  customerEmail: string;
  reservationPhone: string;
  customerPhone: string;
  customerFiscalCode: string;
  customerFlgCompany: boolean;
  showUpdatePersonalDataDialog = false;
  showNewAddressDialog = false;
  customerAddressList: any[] = [];
  selectedCustomerAddress: number;
  catalogIdList: number[] = [];
  personalDataErrorMsg: string;
  reservationErrorMsg: string;
  reservationOkMsg: string;
  progressive = 1;
  transactionId = 1;
  now = new Date();
  reservationPrintList: ReservationPrint[] = [];
  customer: string;
  storeId: number;
  storeName: string;
  stores: SelectItem[] = [];
  deliveryStores: SelectItem[] = [];
  startingBalance: number;
  selectedGifts: any[];
  pointsSpent: number;
  pointsLeft: number;
  acmCode: string;
  cardNo: string;
  catalogDescription: string;
  qrCodePrefix: string;
  idProd: number[] = [];
  storeChannel: string;
  giftFis: number = 0;
  giftDig: number = 0;
  errorEmailPhoneMsg: string;
  errorAddressMsg: string;
  errorCompanyFiscalCodeMsg: string;
  errorCompanyAddressMsg: string;
  errorReservationEmailMsg: string;
  errorStoreMsg: string;
  errorCatalogGiftItemValueChange: string;
  counterError: number = 0;
  editAddress = false;
  divisionId: string;

  constructor(
    public giftService: LoyaltyGiftReservationService,
    private router: Router,
    private reservationService: LoyaltyReservationsService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    public printer: LoyaltyPrintTemplateService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.customer = sessionStorage.getItem('customer');
    this.storeId = +sessionStorage.getItem('storeId');
    this.stores = JSON.parse(sessionStorage.getItem('stores'));
    this.storeName = this.stores.find(store => store.value === this.storeId).label;
    this.startingBalance = +sessionStorage.getItem('startingBalance');
    this.selectedGifts = JSON.parse(sessionStorage.getItem('selectedGifts'));
    this.pointsSpent = +sessionStorage.getItem('pointsSpent');
    this.pointsLeft = +sessionStorage.getItem('pointsLeft');
    this.acmCode = sessionStorage.getItem('acmCode');
    this.cardNo = sessionStorage.getItem('cardNo');
    this.divisionId = sessionStorage.getItem('divisionId');


    this.giftService.getQrCodePrefix('PRE.QRCODE.GABRIELLI').subscribe(res => this.qrCodePrefix = res.param_code);

    this.giftService.getSourceSystemFromStore(this.storeId).subscribe(res => this.storeChannel = res[0].code);



    this.translateService.get([
      'reservations.personalDataError',
      'reservations.reservationError',
      'reservations.reservationOk',
      'reservations.errorEmailPhone',
      'reservations.errorAddress',
      'reservations.errorCompanyFiscalCode',
      'reservations.errorCompanyAddress',
      'reservations.errorReservationEmail',
      'reservations.errorStore',
      'reservations.errorCatalogGiftItemValueChange'
    ]).subscribe(res => {
      this.personalDataErrorMsg = res['reservations.personalDataError'];
      this.reservationErrorMsg = res['reservations.reservationError'];
      this.reservationOkMsg = res['reservations.reservationOk'];
      this.errorEmailPhoneMsg = res['reservations.errorEmailPhone'];
      this.errorAddressMsg = res['reservations.errorAddress'];
      this.errorCompanyFiscalCodeMsg = res['reservations.errorCompanyFiscalCode'];
      this.errorCompanyAddressMsg = res['reservations.errorCompanyAddress'];
      this.errorReservationEmailMsg = res['reservations.errorReservationEmail'];
      this.errorStoreMsg = res['reservations.errorStore'];
      this.errorCatalogGiftItemValueChange = res ['reservations.errorCatalogGiftItemValueChange'];
    });

    this.selectedGifts.forEach(gift => {
      this.setContributions(gift);
      if (gift.deliveryType.toUpperCase() === 'PUNTO VENDITA') {
        this.pdvDelivery = true;
      } else if (gift.deliveryType.toUpperCase() === 'EMAIL/SMS') {
        this.digitalDelivery = true;
      } else if (gift.deliveryType.toUpperCase() === 'INDIRIZZO DI CONSEGNA') {
        this.homeDelivery = true;
      } else if (gift.deliveryType.toUpperCase() === 'PUNTO VENDITA O INDIRIZZO DI CONSEGNA'){
        this.pdvOrHomeDelivery = 'home';
      }
      // Popolo lista CatalogId
      if(this.catalogIdList.indexOf(gift.catalogId) === -1) {
        this.catalogIdList.push(gift.catalogId);
      }
    });
    this.catalogIdList.forEach(id => {
      this.giftService.getStoresByCatalogId(id.toString()).subscribe(res => {
        res.forEach(store => {
          var label = `${store.host_code} - ${store.name}, ${store.address_1}, ${store.city}`;
          if(store.name === null)
            label = `${store.host_code} - --`;
          this.deliveryStores.push({label: label, value: store.id});
        });
        this.selectedPdv = this.stores.find(store => store.value === this.storeId);
        console.log(this.selectedPdv)
      });
      });
    this.getCustomerData();
  }

  /**
   * Popola i campi con i dati personali del cliente
   */
  getCustomerData(updatedAddress?) {
    this.customerAddressList = [];
    if (this.selectedCustomerAddress) {
      this.selectedCustomerAddress = undefined;
    }
    this.giftService.getCustomerAddress().subscribe(res => {
      if (Object.keys(res.delivery_address).length > 0) {
        this.reservationEmail = this.customerEmail = res.delivery_address[0]['email'] || '';
        this.reservationPhone = this.customerPhone = res.delivery_address[0]['contact_number'] || '';
        this.customerFiscalCode = res.delivery_address[0]['vat_fiscal_code'] || '';
        this.customerFlgCompany = res.delivery_address[0]['flg_company'] === 'S' ? true : false;
        // if (this.homeDelivery || this.pdvOrHomeDelivery === 'home') {
        for (let index in res.delivery_address) {
          if(!res.delivery_address[index].toponym){
            res.delivery_address[index].toponym = '';
          }
          this.customerAddressList.push({
            city: res.delivery_address[index].city || '',
            toponym: res.delivery_address[index].toponym_id || '',
            address: res.delivery_address[index].address_1 || '',
            address2: res.delivery_address[index].address_2 || '',
            addressNo: res.delivery_address[index].address_number || '',
            zipCode: res.delivery_address[index].zip_code || '',
            provinceId: res.delivery_address[index].province_id || null,
            provinceCode: res.delivery_address[index].province_code || '',
            surname: res.delivery_address[index].surname || '',
            name: res.delivery_address[index].name || '',
            label: `${res.delivery_address[index].name} ${res.delivery_address[index].surname} - ${res.delivery_address[index].toponym} ${res.delivery_address[index].address_1}, ${res.delivery_address[index].address_number} - ${res.delivery_address[index].zip_code} - ${res.delivery_address[index].city} (${res.delivery_address[index].province_code})`,
            value: index
          });
        }
        if (updatedAddress) {
          if (updatedAddress === 'new address') {
            this.selectedCustomerAddress = this.customerAddressList[this.customerAddressList.length - 1].value;
          } else {
            this.selectedCustomerAddress = this.customerAddressList[+updatedAddress].value;
          }
        } else {
          this.selectedCustomerAddress = this.customerAddressList[0].value;
        }
        // }
      }
    });
  }

  setPdvOrHomeDelivery() {
    if (this.pdvOrHomeDelivery === 'home') {
      this.pdvOrHomeDelivery = 'pdv';
    } else {
      this.pdvOrHomeDelivery = 'home';
    }
  }

  /**
   * Se ritiro in punto vendita, aggiunge il contributo del premio al contributo da pagare alla consegna,
   * altrimenti al contributo da pagare immediatamente in cassa
   */
  setContributions(gift, fromCheckbox = false) {
    for (let i = 1; i <= gift.qty; i++) {
      if (gift.pdv) {
        this.pickupContribution = parseFloat((this.pickupContribution + gift.contribution).toFixed(2));
        if (fromCheckbox) {
          this.immediateContribution = parseFloat((this.immediateContribution - gift.contribution).toFixed(2));
        }
      } else {
        this.immediateContribution = parseFloat((this.immediateContribution + gift.contribution).toFixed(2));
        if (fromCheckbox) {
          this.pickupContribution = parseFloat((this.pickupContribution - gift.contribution).toFixed(2));
        }
      }
    }
  }

  confirmReservation() {
    this.counterError = 0;
    console.log(this.selectedGifts)
    this.selectedGifts.forEach( el => {
      this.giftService.getCatalogGiftItemById(el.id).subscribe(res => {
        // Controllo per i valori dei gift item se sono stati aggiornati durante la selezione
        //TODO  da rivere il controllo perchè questa chiamata  this.giftService.getCatalogGiftItemById(el.id)  non ritorna
        //correttamente il premio pensto come l'unione delle 3 tuple  ma solo tramite l'id sulla catalog_gift_item
          if( el.points && el.points != undefined && res.rdm_points && el.points != res.rdm_points) {
            this.confirmationService.confirm({
              message: this.errorCatalogGiftItemValueChange,
              acceptLabel: 'Ok',
              rejectVisible: false
            });
            this.counterError++;
            return;
          }

          if(el.contribution && el.contribution != undefined && res.rdm_value && el.contribution != res.rdm_value) {
            this.confirmationService.confirm({
              message: this.errorCatalogGiftItemValueChange,
              acceptLabel: 'Ok',
              rejectVisible: false
            });
            this.counterError++;
            return;
          }

      if (!this.customerPhone && !this.customerEmail) {
        // Sempre necessario almeno uno tra mail e telefono in anagrafica
        this.confirmationService.confirm({
          message: this.errorEmailPhoneMsg,
          acceptLabel: 'Ok',
          rejectVisible: false
        });
        this.counterError++;
        return;
      }
      if (this.customerFlgCompany) {
        if (!this.customerFiscalCode) {
          // Se cliente di tipo azienda, sempre necessario codice fiscale
          this.confirmationService.confirm({
            message: this.errorCompanyFiscalCodeMsg,
            acceptLabel: 'Ok',
            rejectVisible: false
          });
          this.counterError++;
          return;
        }
        if (this.customerAddressList.length === 0) {
          // Se cliente di tipo azienda, sempre necessario indirizzo in anagrafica
          this.confirmationService.confirm({
            message: this.errorCompanyAddressMsg,
            acceptLabel: 'Ok',
            rejectVisible: false
          });
          this.counterError++;
          return;
        }
      }
      if (el.type.toUpperCase() === "DIGITALE"){
        // Se premio Digitale, mail di consegna obbligatoria
        if (!this.reservationEmail || !this.regex.test(this.reservationEmail)) {
          this.confirmationService.confirm({
            message: this.errorReservationEmailMsg,
            acceptLabel: 'Ok',
            rejectVisible: false
          });
          this.counterError++;
          return;
        }
      } else if (
          el.deliveryType.toUpperCase() === "INDIRIZZO DI CONSEGNA" ||
          (el.deliveryType.toUpperCase() === "PUNTO VENDITA O INDIRIZZO DI CONSEGNA" && !el.pdv)
        ) {
        // Se consegna a domicilio, indirizzo di consegna obbligatorio
        if (!this.selectedCustomerAddress || !this.reservationPhone) {
          this.confirmationService.confirm({
            message: this.errorAddressMsg,
            acceptLabel: 'Ok',
            rejectVisible: false
          });
          this.counterError++;
          return;
        }
      } else if (
          el.deliveryType.toUpperCase() === "PUNTO VENDITA" ||
          (el.deliveryType.toUpperCase() === "PUNTO VENDITA O INDIRIZZO DI CONSEGNA" && el.pdv)
        ) {
        // Se ritiro in negozio, selezione negozio obbligatoria
        if (!this.selectedPdv) {
          this.confirmationService.confirm({
            message: this.errorStoreMsg,
            acceptLabel: 'Ok',
            rejectVisible: false
          });
          this.counterError++;
          return;
        }
      }
    })
    });
    //refresh necessario per check errori
    setTimeout(() => {
    if (this.counterError <= 0) {
      this.catalogIdList.forEach(id => {
        this.saveReservation(id);
      });
    }
  },500)

  }

  saveReservation(catalogId: number) {
    const reservationData = {
      dt_reservation: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
      store_id: this.storeId,
      card_id: +sessionStorage.getItem('cardId'),
      customer_id: +sessionStorage.getItem('customerId'),
      acm_id: +sessionStorage.getItem('acmId'),
      catalog_id: catalogId,
      points_pre: this.startingBalance,
      points_used: this.pointsSpent,
      email: this.reservationEmail,
      mobile: this.reservationPhone,
      city: this.customerAddressList[this.selectedCustomerAddress].city,
      address: this.customerAddressList[this.selectedCustomerAddress].address,
      address_number: this.customerAddressList[this.selectedCustomerAddress].addressNo,
      zip_code: this.customerAddressList[this.selectedCustomerAddress].zipCode,
      province_id: this.customerAddressList[this.selectedCustomerAddress].provinceId,
      surname: this.customerAddressList[this.selectedCustomerAddress].surname,
      name: this.customerAddressList[this.selectedCustomerAddress].name
    }
    if (this.pdvDelivery || this.pdvOrHomeDelivery === 'pdv') {
      Object.assign(reservationData, {store_pickup_id: this.selectedPdv.value});
    }
    /* if (this.homeDelivery || this.pdvOrHomeDelivery === 'home') {
      Object.assign(reservationData, {
        city: this.customerAddressList[this.selectedCustomerAddress].city,
        address: this.customerAddressList[this.selectedCustomerAddress].address,
        address_number: this.customerAddressList[this.selectedCustomerAddress].addressNo,
        zip_code: this.customerAddressList[this.selectedCustomerAddress].zipCode,
        province_id: this.customerAddressList[this.selectedCustomerAddress].provinceId,
        surname: this.customerAddressList[this.selectedCustomerAddress].surname,
        name: this.customerAddressList[this.selectedCustomerAddress].name
      });
    } */
    this.giftService.saveReservation(reservationData).subscribe(
      res => {
        let delay = 300;
        const debitsToCall = [];
        const items = this.selectedGifts.filter(gift => gift.catalogId === catalogId);
        items.forEach(item => {
          // Ciclo sulla quantità di ogni item
          for (let i = 1; i <= item.qty; i++) {
            const debitData = {
              acm: this.acmCode,
              amnt: item.points,
              card: this.cardNo,
              channel: this.storeChannel,
              // partner: 'KONCENTRO',
              // rsn: '406',
              store: this.storeName.split(' - ')[0],
              transactionId: this.transactionId,
              itm: item.barcode
            };
            debitsToCall.push(this.debit(item, debitData, res.id, delay, catalogId));
            delay += 300;
            this.transactionId++;
          }
        });
        // aspetto che tutte le debit ed item vengano effettuate, poi stampo modulo ed invio mail
        Promise.all(debitsToCall).then(() => {
          this.confirmationService.confirm({
            message: this.reservationOkMsg,
            key: 'confirmRes',
            acceptLabel: 'Ok',
            accept: () => this.completeReservation(res.id),
            rejectVisible: false,
          });
        });
      }
    );
  }

  /**
   * Sottrae i punti dell'item prenotato da quelli del cliente
   */
  debit(item: any, debitData: any, reserVationId: number, delay: number
    , catalogId:number) {
    return new Promise(resolve => {
      // distanzio le varie debit con un delay di 300ms per evitare errori
      setTimeout(() => {
        /* è necessario un secondo di distanza tra le debit
        this.now.setSeconds(this.now.getSeconds() + 1); */
        Object.assign(debitData, {transactionDate: this.now});
        this.giftService.debit(debitData, catalogId).subscribe(() => {
          let giftStatus = 0;
          if (
            (item.deliveryType.toUpperCase() === 'EMAIL/SMS' ||
             item.deliveryType.toUpperCase() === 'INDIRIZZO DI CONSEGNA' ||
             (item.deliveryType.toUpperCase() === 'PUNTO VENDITA O INDIRIZZO DI CONSEGNA' && !item.pdv)
            ) && item.contribution
          ) {
            giftStatus = 1;
          }
          const itemData = {
            reservation_id: reserVationId,
            catalog_gift_itm_id: item.id,
            progr: this.progressive,
            gift_status_id: giftStatus,
            points: item.points,
            value: item.contribution
          };
          this.progressive++;
          if (item.deliveryType.toUpperCase() === 'PUNTO VENDITA O INDIRIZZO DI CONSEGNA' && item.pdv) {
            Object.assign(itemData, {flg_pickup_store: 'S'});
          }
          console.log(item.status);
          this.giftService.saveReservationItem(itemData).subscribe(
            (res) => {
              if(
                (item.type === 'Fisico' && item.deliveryType === 'Indirizzo di consegna' && item.contribution) ||
                (item.type === 'Digitale' && item.contribution) ||
                (item.type === 'Fisico' && item.deliveryType === 'Punto vendita o indirizzo di consegna' && item.contribution && !item.pdv)){
                this.reservationPrintList.push({
                  acm_code: this.acmCode,
                  acm_desc: sessionStorage.getItem('acmDescription'),
                  barcode: item.barcode,
                  card_no: this.cardNo,
                  codice_cliente: sessionStorage.getItem('customerCode'),
                  cust_name: sessionStorage.getItem('customerName'),
                  cust_surname: sessionStorage.getItem('customerSurname'),
                  delivery_type: item.deliveryType,
                  dt_reservation: this.now.toString(),
                  gift_code: item.code,
                  gift_description: item.name,
                  gift_type: item.type,
                  gift_type_id: item.typeId,
                  id: item.id,
                  num_reservation: res.reservation_id,
                  points: item.points,
                  prefix_qrcode: this.qrCodePrefix,
                  status: item.status,
                  value: item.contribution,
                  quantity: item.qty,
                  catalog_desc: item.catalogDesc,
                  pay_code: res.payCode,
                  auth_pay_code: res.authPayCode
                });
                //elimina i duplicati nelle stampe
                this.reservationPrintList = this.reservationPrintList.filter((test, index, array) =>
                index === array.findIndex((findTest) =>
                  findTest.barcode === test.barcode
                )
              );
              }
              resolve(null);
            },
            err => {
              console.error(err);
              this.confirmationService.confirm({
                message: this.reservationErrorMsg,
                acceptLabel: 'Ok',
                accept: () => this.credit(item.points, item.barcode, catalogId),
                rejectVisible: false
              });
              resolve(null);
            }
          );
        });
      }, delay);
    })

  }

  /**
   * Rimmborsa punti (amount) in caso di fallimento salvataggio dopo debit riuscita
   */
  credit(amount: number, barcode: string, catalogId: any) {
    const creditData = {
      acm: this.acmCode,
      amnt: amount,
      card: this.cardNo,
      channel: this.storeChannel,
      // partner: 'KONCENTRO',
      // rsn: '200',
      store: this.storeName.split(' - ')[0],
      transactionDate: new Date(),
      transactionId: this.transactionId,
      itm: barcode
    };
    this.giftService.credit(creditData, catalogId).subscribe(() => this.goBack());
  }

  completeReservation(reservationId: number) {
    if (this.reservationPrintList.length > 0) {
      let cardNoOld = this.reservationPrintList[0].card_no
      this.reservationPrintList[0].card_no = this.commonService.getCardWithCheckdigit(cardNoOld);
      this.printer.generateReportPagamentoComplete(this.reservationPrintList);
      this.addButton();

      /*
      this.reservationService.getCardCheckDigit(this.reservationPrintList[0].card_no).subscribe(res => {
        this.reservationPrintList[0].card_no = res
        this.printer.generateReportPagamentoComplete(this.reservationPrintList);
        this.addButton();
      });
      */
    }
    const flagMail = this.customerEmail === this.reservationEmail;
    this.giftService.sendConfirmReservationEmail(null, reservationId, null, flagMail).subscribe();
    if(this.reservationPrintList.length == 0){
      this.router.navigate([`loyalty/balance/${sessionStorage.getItem('customerId')}`]);
    }

  }

  goBack() {
    window.history.back();
  }

  refreshCustomerData(updatedAddress?) {
    this.showUpdatePersonalDataDialog = false;
    this.showNewAddressDialog = false;
    this.getCustomerData(updatedAddress);
  }

  ngOnDestroy() {
    // rimuovo eventuali selezioni del checkbox pdv
    this.selectedGifts.forEach(gift => {
      if (gift.deliveryType.toUpperCase() === 'PUNTO VENDITA O INDIRIZZO DI CONSEGNA') {
        gift.pdv = false;
      }
    })
  }

  /**
   * Override del metodo che aggiunge il bottone 'Close', in modo tale che ritorni alla pagina "loyalty/balance/customerId"
   */
  addButton(){
    this.printer.addCloseButton = () => {
      const userButton = this.printer.viewerPagamentoCassa.jsObject.SmallButton('userButton', 'Close', 'emptyImage');
      const self = this;
      userButton.action = function () {
      self.printer.showMeReport = false;
      self.router.navigate([`loyalty/balance/${sessionStorage.getItem('customerId')}`]);
        $('body').css('overflow', 'auto');
      }

    const toolbarTable = this.printer.viewerPagamentoCassa.jsObject.controls.toolbar.firstChild.firstChild;
    const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
    const userButtonCell = buttonsTable.rows[0].insertCell(0);
    userButtonCell.className = 'stiJsViewerClearAllStyles';
    userButtonCell.appendChild(userButton);

    };
  }

  /**
   * Apre dialog di aggiunta nuovo indirizzo
   */
  openAddAddressDialog() {
    this.editAddress = false;
    this.showNewAddressDialog = true;
  }

  /**
   * Apre dialog di modifica indirizzo selezionato
   */
  openEditAddressDialog() {
    this.editAddress = true;
    this.showNewAddressDialog = true;
  }

  changeStore(event) {
    this.selectedPdv = event;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-gift-reservation/confirm-gift-reservation-form/confirm-gift-reservation-form.component.ts